import { render, staticRenderFns } from "./shopping-car.vue?vue&type=template&id=1004128f&scoped=true&"
import script from "./shopping-car.vue?vue&type=script&lang=js&"
export * from "./shopping-car.vue?vue&type=script&lang=js&"
import style0 from "./shopping-car.vue?vue&type=style&index=0&id=1004128f&prod&lang=scss&"
import style1 from "./shopping-car.vue?vue&type=style&index=1&id=1004128f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004128f",
  null
  
)

export default component.exports